import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
    selector: 'function-setting-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class FunctionFormDialogComponent implements OnInit
{
  public formGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    rate: new FormControl('', Validators.required)
  });
  action: string;
  dialogTitle;
  functionType;

    constructor(
        public dialogRef: MatDialogRef<FunctionFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
    )
    {
        this.action = data.action;

        if ( this.action === 'edit' )
        {
            this.dialogTitle = 'function.edit';
            this.functionType = data.type;
        }
        else
        {
            this.dialogTitle = 'function.new';
        }
    }

    ngOnInit()
    {
      if (this.action === 'edit') {
        this.formGroup.patchValue(this.functionType);
      }
    }
}
